export default "mutation SetMyCountryMutation($input: SetMyCountryMutationInput!) {\n  setMyCountry(input: $input) {\n    success\n  }\n}\n";